import { ROUTE_NAMES } from './routeNames.const'

export const routeAdvisorRiskProfile = {
  path: '/advisor-risk-profile',
  name: ROUTE_NAMES.advisorRiskProfile,
  component: () =>
    import(
      /* webpackChunkName: "AdvisorRiskProfile" */ 'src/pages/AdvisorRiskProfile/AdvisorRiskProfile.vue'
    ),
}
